import React from 'react';
import styles from './styles.module.scss';

export interface RankPillProps {
  rank: number;
  /** Positioning (e.g. a card corner) is the consumer's job. */
  className?: string;
  testId?: string;
}

/** User's leaderboard place in a tournament as a compact accent pill ("#1"). */
export const RankPill: React.FC<RankPillProps> = ({ rank, className, testId }) => (
  <span className={[styles.rank, className].filter(Boolean).join(' ')} data-testid={testId}>
    #{rank}
  </span>
);

export default RankPill;
